<mat-progress-bar *ngIf="loading" color="primary" mode="determinate" [value]="percent"></mat-progress-bar>
